import {useLocalSearchParams} from "expo-router";
import {AchievementsScreen} from "@/components/achievement/AchievementsScreen";

export default function Achievements() {
    const {orgId} = useLocalSearchParams<{ orgId: string }>();
    return (
        <AchievementsScreen orgId={orgId}/>
    );
}